export function createTypesRegex(types: string[], prefix: string) {
  const regExpSafeNames = types
    .map((type) => type.replace('+', '\\+'))
    .map((i) => i.toLowerCase());

  return new RegExp(`^${prefix}\\/(${regExpSafeNames.join('|')})$`);
}
